<template>
    <el-dialog
      :visible="visible"
      :title="customVoidMessage || `Void this Transaction?`"
      width="30%"
      size="small"
      style="width: 50% !important; left: 25%"
      :show-close="false"
      @close="handleCancel"
    >
      <div class="mb-2" v-if="visible">
        <DateField
          :customStyle="{ width: '100%' }"
          :name="`void__date`"
          :disabled="false"
          v-model="selectedDate"
          class="keynav"
        />
      </div>
  
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancel">Cancel</el-button>
          <el-button type="primary" @click="handleConfirm">Submit</el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  
  <script>
  import DateField from '@/components/InputComponents/DateField.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'

  export default {
    name: 'CustomVoidDate',
    components: { DateField },
    props: {
      customVoidMessage: {
        type: String,
        default: ''
      },
      TrnsDate: {
        type: String,
        default: null
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible (newVal) {
        if (!newVal) {
          this.selectedDate = this.getVoidDate()
        }
      }
    },
    mounted () {
      this.selectedDate = this.getVoidDate()
      this.render++
    },
    data () {
      return {
        render: 0,
        selectedDate: this.getVoidDate()
      }
    },
    methods: {
      getVoidDate () {
        // const d1 = new Date(this.TrnsDate).getTime();
        // const d2 = new Date(date).getTime();

        // if (d1 > d2) return this.TrnsDate
        return getSimpleDate(new Date(), 'yyyy-mm-dd') // return always, current date as void date, as per the requirement
      },
      handleConfirm () {
        if (new Date(this.TrnsDate).getTime() > new Date(this.selectedDate).getTime()) return this.$notify({ title: 'Error', message: `Void date: Void date cannot be earlier than the transaction date.`, type: 'error' })
        this.$emit('confirm', this.selectedDate)
        this.$emit('update:visible', false)
      },
      handleCancel () {
        this.selectedDate = this.getVoidDate()
        this.$emit('cancel')
        this.$emit('update:visible', false)
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/RouteComponents/VoidDateEditor.vue